<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12 small-columns-12">
            <mat-label>{{ 'time-off-v3.approvalFlowName' | translate }}</mat-label>
            <input
                name="approvalFlowName"
                #approvalFlowName="ngModel"
                placeholder="{{ 'time-off-v3.egManagerApproval' | translate }}"
                required
                [(ngModel)]="timeOffApprovalFlow.name"
                matInput
                type="text"
            />
            <mat-error *ngIf="approvalFlowName.invalid">{{ approvalFlowName.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
    <div>
        <mat-slide-toggle name="slideToggle" color="primary" [(ngModel)]="timeOffApprovalFlow.isAutomatic"
            >{{ 'time-off-v3.automaticApproval' | translate }}
        </mat-slide-toggle>
    </div>
</form>
